import { useMemo } from "react"
import { useFunnelGraphModel } from "./model"
import { useGrid } from "../../../components/grid"
import { useTooltip } from "../../../components/toolTip"

type useFunnelGraphOptionRenderProps<T> = {
	graphData: ReturnType<typeof useFunnelGraphModel<T>>
}
export const useFunnelGraphOptionRender = <T,>({
	graphData
}: useFunnelGraphOptionRenderProps<T>) => {
	const grid = useGrid({})
	const tooltip = useTooltip({ trigger: 'item', is100: true })

	const data = useMemo(
		() => graphData?.data.map((r) => ({
			code: r.code,
			name: r.name,
			value: r.percentage,
			itemStyle: r.itemStyle
		})) ?? [],
		[graphData]
	)
	return {
		//animation: false,
		tooltip,
		grid,
		series: {
			type: 'funnel',
			min: 0, max: 1,
			top: 0, bottom: 0,
			left: 0, right: 0,
			minSize: '0%',
			maxSize: '100%',

			itemStyle: {
				borderWidth: 0
			},
			emphasis: {
				itemStyle: {
					shadowBlur: 10,
					shadowOffsetX: 0,
					shadowColor: 'rgba(0, 0, 0, 0.5)',
				}
			},
			label: {
				show: true,
				position: 'inside'
			},
			data
		},
		textStyle: {
			fontFamily: 'Noto Sans JP,sans-serif'
		}
	}
}